// ============================================
// ZAVELA CUSTOM JAVASCRIPT
// ============================================

// -------------------------------------------
// PRODUCT PAGE - Collapsible Accordion
// Only one row open at a time + smooth animation
// -------------------------------------------
(function() {
  'use strict';
  
  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductAccordion);
  } else {
    initProductAccordion();
  }
  
  function initProductAccordion() {
    // Find ALL accordion details on the page (not just in one container)
    const allDetails = document.querySelectorAll('.product__accordion details');
    
    if (allDetails.length === 0) return; // Exit if no accordions found
    
    // Add click listener to each accordion
    allDetails.forEach((targetDetail) => {
      targetDetail.addEventListener('click', (e) => {
        // Prevent default to handle manually
        e.preventDefault();
        
        const isOpen = targetDetail.hasAttribute('open');
        
        if (isOpen) {
          // Close if already open (normal speed)
          closeDetail(targetDetail, false);
        } else {
          // Close ALL others first (fast) - across entire page
          allDetails.forEach((detail) => {
            if (detail !== targetDetail && detail.hasAttribute('open')) {
              closeDetail(detail, true);
            }
          });
          
          // Then open the clicked one
          openDetail(targetDetail);
        }
      });
    });
    
    // Helper: Open with animation
    function openDetail(detail) {
      const content = detail.querySelector('.accordion__content');
      
      content.style.height = '0px';
      content.style.overflow = 'hidden';
      detail.setAttribute('open', '');
      
      const targetHeight = content.scrollHeight;
      
      requestAnimationFrame(() => {
        content.style.transition = 'height 0.2s ease-out';
        content.style.height = targetHeight + 'px';
      });
      
      setTimeout(() => {
        content.style.height = 'auto';
        content.style.overflow = 'visible';
      }, 200);
    }
    
    // Helper: Close with animation
    function closeDetail(detail, fast = false) {
      const content = detail.querySelector('.accordion__content');
      
      const currentHeight = content.scrollHeight;
      content.style.height = currentHeight + 'px';
      content.style.overflow = 'hidden';
      
      // Fast close for auto-close when opening another, normal for manual close
      const duration = fast ? 0.15 : 0.2;
      const durationMs = fast ? 150 : 200;
      
      requestAnimationFrame(() => {
        content.style.transition = `height ${duration}s ease-in`;
        content.style.height = '0px';
      });
      
      setTimeout(() => {
        detail.removeAttribute('open');
        content.style.transition = '';
        content.style.height = '0px'; // Fix für Bounce
      }, durationMs);
    }
  }
  
})();


// # CUSTOM MARC – Loop Widget + ATC Button Currency Suffix + Decimalstellen weg wenn 00
(function () {
  const SUFFIX_CURRENCIES = ['CAD', 'AUD', 'NZD'];
  const currency = window.Shopify?.currency?.active;

  function stripZeros(text) {
    return text.trim().replace(/\.00$/, '');
  }

  function needsSuffix(text) {
    return SUFFIX_CURRENCIES.includes(currency) && !text.trim().endsWith(currency);
  }

  function patchPriceSpans() {
    // ATC Button Preis
    document.querySelectorAll('.loop-widget-button-price').forEach(span => {
      let cleaned = stripZeros(span.textContent);
      if (needsSuffix(cleaned)) cleaned = cleaned + ' ' + currency;
      if (span.textContent.trim() !== cleaned) span.textContent = cleaned;
    });

    // Widget Hauptpreis (mit Suffix)
    document.querySelectorAll('.loop-widget-purchase-option-price').forEach(span => {
      let cleaned = stripZeros(span.textContent);
      if (needsSuffix(cleaned)) cleaned = cleaned + ' ' + currency;
      if (span.textContent.trim() !== cleaned) span.textContent = cleaned;
    });

    // Widget Compare-Preis (nur .00 strippen, kein Suffix)
    document.querySelectorAll('.loop-widget-purchase-option-compare-at-price').forEach(span => {
      if (span.classList.contains('loop-display-none')) return;
      const cleaned = stripZeros(span.textContent);
      if (span.textContent.trim() !== cleaned) span.textContent = cleaned;
    });
  }

  const observer = new MutationObserver(patchPriceSpans);
  observer.observe(document.body, { childList: true, subtree: true, characterData: true });

  document.addEventListener('DOMContentLoaded', patchPriceSpans);
})();